import {
    IP_ADDRESS_LIST_INITIATED,
    IP_ADDRESS_INITIATED,
    IP_ADDRESS_LOADED,
    IP_ADDRESS_FAILED,
    IP_ADDRESS_LIST_LOADED,
    IP_ADDRESS_COUNT_INITIATED,
    IP_ADDRESS_COUNT_LOADED,
    IP_ADDRESS_COUNT_FAILED
  } from "../actions/IPAddressAction";
  
  const initialState = {
    listdata: [],
    data: [],
    merchantCount : {
      active_count : 0,
      inactive_count : 0,
      pending_count : 0,
      total_count : 0,
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case IP_ADDRESS_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case IP_ADDRESS_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case IP_ADDRESS_INITIATED:
        return { ...state, loading: true, error: null};
      case IP_ADDRESS_LOADED:
        const updatedObj = Object.fromEntries(
            Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case IP_ADDRESS_COUNT_INITIATED:
          return { ...state};
      case IP_ADDRESS_COUNT_LOADED:
          return { ...state, merchantCount: action.payload };
      case IP_ADDRESS_COUNT_FAILED:
          return { ...state };
      case IP_ADDRESS_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;